
export const APIPath='https://admin.magicalvacation.com';

export const token ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJrZXkiOiJWdVhhNVRvWkdwWXhQc2syR1ZXWnkyZmNCMTd0NVN6NGV0Y0RXaTlkMVZBTUlaaWNOVEthNVlnUzd1NmRDNlF3dGwwbHBEdkdnYSs1UGpSL3VIYm1WSjBrTzl6Z2ZIbS9mZ05TQVJJQStZQWZmUlpJL0JCZEJQVTZNSXJDRDM2OSIsImlhdCI6MTc4NzA1MjQ5MCwiZXhwIjoxNzg5NjQ0NDkwfQ.B7xHiElO3Rs_75xPePYAKQ5_kajEVcRWV9Skv1w_Yqk"
